import React, { ChangeEvent, SVGProps } from "react";
import Select, { Option } from "@ingka/select";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/forms/dist/style.css";

interface SelectProps {
  id: string;
  label?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLSelectElement>, withHint: boolean) => void;
  ssrIcon?: (prefix?: string) => SVGProps<SVGElement>[];
  value?: string;
  required?: boolean;
}
interface OptionProps {
  key?: string;
  value?: string;
  name?: string;
}

export const FixaSelect = (props: SelectProps) => {
  return <Select {...props} />;
};

export const FixaOption = (props: OptionProps) => {
  return <Option {...props} />;
};
